<div class="element">
  <div class="section-1"></div>
  <div class="section-2">
    <div class="d-flex justify-content-center align-items-center w-100 h-100">
      <div class="card-3">
        <div class="position-relative">
          <div class="row">
            <div
              class="col-12 d-flex justify-content-center align-items-center"
            >
              <p class="log1">FMS</p>
            </div>
            <div class="col-12">
              <p class="log2">Financial Management Service</p>
              <div class="col-12">
                <h3
                  class="card-title head-1 d-flex justify-content-center align-items-center mt-2"
                >
                  Forgot Password?
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body mt-3">
          <form [formGroup]="forgotLoginForm">
            <div class="row mt-1 mb-2">
              <div class="col-12">
                <input
                  class="form-control form-control-1"
                  style="border-color: #ced4da"
                  placeholder="Email"
                  type="text"
                  autocomplete="off"
                  [(ngModel)]="email"
                  formControlName="email"
                  name="email"
                />             
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <input
                  class="form-control form-control-1"
                  style="border-color: #ced4da"
                  placeholder="AgencyCode"
                  type="text"
                  autocomplete="off"
                  [(ngModel)]="agencycode"
                  formControlName="Agencycode"
                  name="agencycode"
                />                
              </div>
            </div>
            <div class="row mt-3">
              <div class="col mt-2 fogot-footer">
                <span class="f-1 d-flex flex-column">
                  <button
                    class="btn btn_md"
                    style="border-radius: 30px"
                    (click)="forgotpassword(email, agencycode)"
                    [disabled]="forgotLoginForm.invalid || IsButtonDisable"
                  >
                    Proceed
                  </button></span
                >
                <span class="f-2 d-flex flex-column">
                  <button
                    class="btn btn_md"
                    style="border-radius: 30px"
                    (click)="close()"
                  >
                    Cancel
                  </button></span
                >
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
